import { Slide } from '@/components/core/Slide';
import { WebContent } from '@/components/web/WebContent';
import diffusionGif from './22-diffusion.gif';
import audioFile from './22-diffusion.mp3';

const transcript = `
  Nee, klopt Jonathan. Voor synthografie gebruiken we tegenwoordig andere technieken. GANs waren een geweldige eerste 
  stap, maar inmiddels zijn er nieuwe generatieve modellen, zoals diffusion models, die beter presteren.

  Deze modellen werken anders: ze beginnen met ruis – een soort willekeurige stipjes – en zetten dat stap voor stap om 
  in iets herkenbaars, zoals een gezicht, een landschap, of een complex kunstwerk. Dit proces is preciezer en biedt 
  meer controle dan GANs. Modellen zoals MidJourney, DALL-E en Stable Diffusion gebruiken deze techniek, net als veel 
  andere generatieve systemen die je tegenwoordig ziet.

  Dus nee, GANs zijn niet meer de standaard voor synthografie, maar ze hebben wel de basis gelegd voor alles wat 
  daarna kwam.
`;

// Jonathan: fascinerend inderdaad. wat kun je nog meer vertellen?

export const slide = () => {
  return (
    <Slide notes={transcript} audio={audioFile} visualizer="bottom-right" networkBackground="full">
      <div className="flex flex-col items-center justify-center h-full">
        <WebContent
          animation={{
            type: 'fade',
            delay: 0,
            duration: 800,
          }}
        >
          <h2 className="text-5xl mb-12">Diffusion Models</h2>
        </WebContent>
        <WebContent
          animation={{
            type: 'fade',
            delay: 2000,
            duration: 1000,
          }}
        >
          <div className="w-[800px]">
            <img
              src={diffusionGif}
              alt="Diffusion process animation showing noise becoming an image"
              className="w-full rounded-lg"
            />
          </div>
        </WebContent>
      </div>
    </Slide>
  );
};
